import $  from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import ConsultWidget from './app';
import './styles.scss';
export default class ConsultWidgetModule{
	constructor(config,$modules){
		if(config==null){
			return;
		}
	    $modules.each((index,el)=>{
	    	let $el = $(el);
	    	if($el.hasClass('module-loaded')){
	    		return;
	    	}
	    	let configId = $el.data('config-id');
	    	let moduleData = config.find( (data) => {
	    		return data['config-id']==configId;
	    	})
	    	if(!moduleData) return;
	    	let props = $.extend({},moduleData.settings);
	    	props.copy = $.extend({},moduleData.copy);
	    	props.user = {
	    		isLoggedIn: window.medscape.user.isLoggedIn,
	    		professionId: window.medscape.user.professionId
	    	};
	    	ReactDOM.render(React.createElement(ConsultWidget,props),el);
	    	$el.addClass('module-loaded');
	    })
	}
}
ConsultWidgetModule.selector = '[data-module="ConsultWidget"]'
ConsultWidgetModule.init = (config,$modules) => {
	$modules = $modules || $(ConsultWidgetModule.selector);
	if($modules.length>0){
		new ConsultWidgetModule(config,$modules);
	}
}




// WEBPACK FOOTER //
// ./medscape_modules/consult-widget/index.js